const MASK = '***'

const SENSITIVE_KEYS = new Set(
  [
    'password',
    'newPassword',
    'currentPassword',
    'verificationCode',
    'authCode',
    'certCode',
    'token',
    'accessToken',
    'refreshToken',
    'rememberMe',
    'access_token',
    'refresh_token',
    'id_token',
    'socialId',
    'username',
    'authorization',
    'cookie',
    'ssn',
    'residentNumber',
    'cardNumber',
    'phoneNumber',
    'cellNumber',
  ].map(key => key.toLowerCase())
)

const isSensitive = (key: string): boolean =>
  SENSITIVE_KEYS.has(key.toLowerCase())

/** 파일 바디는 바이트 단위로 풀어헤치면 로그가 수십만 줄이 된다. 크기만 남긴다. */
const describeBinary = (value: unknown): string | null => {
  if (value instanceof ArrayBuffer) return `[binary ${value.byteLength} bytes]`
  if (ArrayBuffer.isView(value)) return `[binary ${value.byteLength} bytes]`
  if (value instanceof Blob) return `[blob ${value.size} bytes]`
  if (value instanceof FormData) return '[form-data]'
  return null
}

export const maskSensitive = (value: unknown): unknown => {
  const binary = describeBinary(value)
  if (binary) return binary

  if (Array.isArray(value)) return value.map(maskSensitive)

  if (typeof value !== 'object' || value === null) return value

  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [
      key,
      isSensitive(key) ? MASK : maskSensitive(item),
    ])
  )
}
